import React from 'react';

export default function Footer() {
  return (
    <footer className="max-w-4xl mx-auto px-4 sm:px-6 py-8 text-center text-xs text-gray-400">
      Powered by <a href="https://www.matterking.com" className="text-teal-600 hover:text-teal-800 focus:outline-none focus:underline">Matter King</a>
    </footer>
  );
}
